export default "__VITE_ASSET__BBjCroaN__"